module.exports = __webpack_public_path__ + "img/sankaku_80_blue.9536ddbd.png";